import React from 'react';
import logo from "../../../assets/logo.png";
import logoStepapp from "../../../assets/images/logo/logo-light.svg";

const Logo = () => {
  return (
    <div className="uk-text-center uk-margin logo my-2 p-2">
      <img src={logoStepapp} alt="STEPapp" width="200px" height="auto" className="img-fluid my-2"/>
    </div>
  );
};

export default Logo;
